export enum VersionType {
  ALTERNATE = 'alternate',
  LEGACY = 'legacy',
}
